module.exports = __webpack_public_path__ + "static/media/contract_small.7866d276.jpg";